import { Typography, Box, SxProps, Theme } from '@mui/material';

import { LineBadgesItem } from './LineBadgesItem';
import { LineIconItem } from './LineIconItem';
import { LinePillsItem } from './LinePillsItem';
import { ScoopSummaryItem, ScoopStatItem } from './types';

type TheScoopProps = Readonly<{
  summaryItems: ScoopSummaryItem[];
  statItems: ScoopStatItem[];
}>;

export const TheScoop = ({ summaryItems, statItems }: TheScoopProps) => {
  return (
    <Box sx={contentSx}>
      <Box sx={summaryContainerSx}>
        {summaryItems.map((item, index) => (
          <Box key={index}>
            {item.title && (
              <Typography
                variant="text-md-bold"
                component="span"
                color={({ backrs }) => backrs.colors['Brand/500']}
              >
                {item.title}:{' '}
              </Typography>
            )}
            <Typography variant="text-md-regular" component="span">
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={statsInfoContainerSx}>
        {statItems.map((item, index) => renderStatItem(item, index))}
      </Box>
    </Box>
  );
};

const renderStatItem = (item: ScoopStatItem, index: number): React.ReactNode => {
  switch (item.kind) {
    case 'text':
      if (!item.text) return null;

      return (
        <LineIconItem
          key={index}
          title={item.title}
          iconName={item.iconName}
          text={item.text}
          info={item.info}
        />
      );
    case 'pills':
      if (item.pills.length === 0) return null;

      return <LinePillsItem key={index} title={item.title} pills={item.pills} info={item.info} />;
    case 'badges':
      if (item.badges.length === 0) return null;

      return (
        <LineBadgesItem key={index} title={item.title} badges={item.badges} info={item.info} />
      );
  }
};

const contentSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-4xl'],
  '@container (min-width: 600px)': {
    flexDirection: 'row',
  },
});

const summaryContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  '@container (min-width: 600px)': {
    width: '66%',
  },
});

const statsInfoContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: backrs.spacing['spacing-3xl'],
  '@container (min-width: 600px)': {
    display: 'flex',
    flexDirection: 'column',
    gridTemplateColumns: '1fr',
    width: '35.5%',
  },
});
